import { Globe } from "lucide-react";
import styled from "styled-components";
import { useLanguage } from "../contexts/language";
import { languages } from "../constants/translation";

const SwitcherButton = styled.button`
  display: flex;
  align-items: center;
  gap: 6px;
  border-radius: 8px;
  border: 1px solid #e5e5e5;
  background-color: #f9f9f9;
  padding: 6px 8px;
  font-size: 13px;
  font-weight: 500;
  color: #333;
  transition: background-color 0.2s;
  cursor: pointer;

  @media (min-width: 480px) {
    padding: 8px 12px;
    font-size: 14px;
  }

  &:hover {
    background-color: rgba(201, 169, 97, 0.1);
  }

  svg {
    width: 16px;
    height: 16px;
  }
`;

export const LanguageSwitcher = () => {
  const { language, changeLanguage } = useLanguage();

  const toggleLanguage = () => {
    const nextLanguage = language === "en" ? "id" : "en";
    changeLanguage(nextLanguage);
  };

  const currentLang = languages.find((l) => l.code === language);

  return (
    <SwitcherButton onClick={toggleLanguage} aria-label="Switch language">
      <Globe />
      <span>{currentLang?.label || "EN"}</span>
    </SwitcherButton>
  );
};
